import { render, staticRenderFns } from "./DetailConversationPart.vue?vue&type=template&id=170f4314"
import script from "./DetailConversationPart.vue?vue&type=script&lang=ts"
export * from "./DetailConversationPart.vue?vue&type=script&lang=ts"
import style0 from "./DetailConversationPart.vue?vue&type=style&index=0&id=170f4314&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports